import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=d4cb1212&scoped=true&"
var script = {}
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=d4cb1212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cb1212",
  null
  
)

export default component.exports